import React, { useState } from 'react';
import { Timestamp } from "firebase/firestore";
import { useUser } from "../../../../context/UserContext.tsx";
import { BetDetails, Future, OddFuture } from "../../../../models/MyBetModel.tsx";
import { useBetContext } from "../../../../context/BetContext.tsx";
import { SelectedOddDisplay } from "../strainght/SelectedOddDisplay.tsx";
import "../../../../styles/Future.css"
import { calcProfit, calcStake, formatNumbersInLabel } from "../../../../helpers/functions.tsx";
import { lockPageScroll } from "../../../../helpers/scrollPageToTop.ts";
import { DEFAULT_PROPS_LOGO } from "../../modals/BetLogo.tsx";

const INITIAL_VISIBLE_ODDS = 5;

interface IFuturegameComponents {
    game: Future,
    onShowBetsModal: Function,
    setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
    isLast?: boolean;
    compact?: boolean;
}

export function FutureGames(props: IFuturegameComponents) {

    const { game, setErrorMessage, isLast, compact } = props;
    const currentGame = game as Future;
    const gameTimeDate = new Date(game.start_date ?? '')
    const time = gameTimeDate.toLocaleTimeString('en-US', {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: "short"
    });
    const gameTime = Timestamp.fromDate(new Date(currentGame.start_date));
    const { bets, upsertBet } = useBetContext();
    const date = new Date(game.start_date);
    const weekday = date.toLocaleString('en-US', { weekday: 'long' });
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const { user } = useUser();
    const [showAllOdds, setShowAllOdds] = useState(false);

    if (!user?.userName) {
        throw new Error("User not authenticated");
    }
    const formattedDate = `${weekday} ${month}/${day}`;
    const sortedOdds = [...(game.odds ?? [])].sort((a, b) => a.price - b.price);
    const totalOdds = sortedOdds.length;
    const visibleOdds = showAllOdds ? sortedOdds : sortedOdds.slice(0, INITIAL_VISIBLE_ODDS);
    const remainingOdds = totalOdds - INITIAL_VISIBLE_ODDS;
    const hasMoreOdds = !showAllOdds && remainingOdds > 0;
    const isLive = Boolean(compact);

    const handleSeeMore = () => {
        setShowAllOdds(true);
    };

    const _build = (betAmount: number, selected: OddFuture): BetDetails => {
        const price = selected?.price;

        let risk = 0;
        let finalReward = 0;

        if (price > 0) {
            risk = betAmount;
            finalReward = calcProfit(risk, price);
        } else {
            finalReward = betAmount;
            risk = calcStake(finalReward, price);
        }

        const newBet = {
            // fixture_id: game.id,
            id_selection: selected.id,
            bet: risk,
            reward: finalReward,
            sport: game.sport.name,
            league: game.league.name,
            gameId: selected.team_id,
            betName: `${selected.name}`,
            teamId: selected.name,
            betDate: Timestamp.now(),
            gameDate: gameTime,
            betStatus: 'pending',
            betType: 'Contest',
            odd: selected,
            marketName: game.name,
            logo: DEFAULT_PROPS_LOGO,
            tournament: game.tournament,
            ...(isLive ? { gameType: 'live' } : {}),
        } as BetDetails;

        return newBet;
    };

    const onRequestBetsModal = (update?: any, openModal: boolean = false) => {
        if (user.status !== "Active") {
            setErrorMessage("Your account is in read-only mode."
            );
            return;
        }
        if (!update) {
            return;
        }
        const reward = update.reward ?? 0;
        const oddId = update.odd?.id;

        if (oddId === undefined) return;
        if (!openModal && !reward) return;

        const odd = game.odds.find(o => o.id === oddId);
        if (!odd) return;

        if (openModal) lockPageScroll();

        const newBet = _build(reward, odd);
        const updatedBets = (() => {
            const exists = bets.find(b => b.id_selection === newBet.id_selection);

            if (exists) {
                return bets.map(b =>
                    b.id_selection === newBet.id_selection ? newBet : b
                );
            }

            return [...bets, newBet];
        })();
        upsertBet(newBet);

        if (openModal) {
            props.onShowBetsModal(updatedBets);
        }
    };

    return (
        <div className='gamesGroup'>
            {!compact && (
                <>
                    <span className='name-game-future teko'>{game.name}</span>

                    <div className="header-table">
                        <div className="date-future">
                            <span className="group ps-1">{formattedDate}</span>
                        </div>
                        <div className="wager-future">
                            <span className="title-table-game moneylin-span">MONEYLINE</span>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <span className="group-text teko">{time}</span>
                    </div>
                </>
            )}
            {visibleOdds.map((selection, index) => {
                const bet = bets.find(bet => bet.id_selection === selection.id);

                return (
                    <div key={selection.id ?? index} className="odd-item">
                        <div className="team-future">
                            <span className="team-name">{formatNumbersInLabel(selection.name)}</span>
                        </div>
                        <SelectedOddDisplay
                            o={selection}
                            currentBet={bet}
                            onRequestBetsModal={onRequestBetsModal}
                            isFuture={true}
                        />
                    </div>
                );
            })}
            {hasMoreOdds && (
                <button
                    type="button"
                    className="teko future-see-more"
                    onClick={handleSeeMore}
                >
                    Show all
                    <span className="future-see-more-count">+{remainingOdds}</span>
                </button>
            )}
            {!compact && isLast && <div className="future-odds-end-line" aria-hidden="true" />}
        </div>
    )
}
